const voltageOptions = [
  {id: 'high', translationKey: 'charging.inputs.advanced.voltageLevel.high'},
  {id: 'low', translationKey: 'charging.inputs.advanced.voltageLevel.low'},
];

export default voltageOptions;
